export const siteSettings = {
  name: "Global Forex Trade",
  link: "https://globalforextrade.net/",
  email: "support@globalforextrade.net/",
  appLink: "https://app.globalforextrade.net/",
};
